import { BaseRouteRpc, RoleType } from '../../../../../core';
import { PaymentHistoryFixStuckRequestSchema } from './request';
import { PaymentHistoryFixStuckResponseSchema } from './response';
  
/**
* @description
* Admin-only recovery endpoint for a stuck payment. It checks the latest Stripe PaymentIntent linked to the order. Failed transitions require `confirmFailed: true`; Stripe `processing` and `requires_capture` statuses are never changed automatically.
*
* Request interface:
* ```
* export interface PaymentHistoryFixStuckRequestSchema extends ContractData {
*     confirmFailed: boolean;
*     orderId:       number;
* }
*
* ```
* Response interface:
*
* ```
* export interface PaymentHistoryFixStuckResponseSchema extends ContractData {
*     action:               Action;
*     orderId:              number;
*     paymentHistoryId:     number;
*     paymentHistoryStatus: string;
*     paymentIntentId?:     string;
*     stripeStatus:         string;
* }
*
* export type Action = "marked_failed" | "requires_action" | "confirmation_required" | "not_changed" | "manual_review_required";
*
* ```
*/
export class PaymentHistoryFixStuckRouteRpc extends BaseRouteRpc {
  static method = 'payment-history-fix-stuck';

  static request: PaymentHistoryFixStuckRequestSchema;
  static response: PaymentHistoryFixStuckResponseSchema;

  static role = RoleType.admin;
}
